import '../../styles/Home.css';

import Label from '../atoms/Label.js';
import React from 'react';
import { getEmbedUrl } from '../../hooks/getEmbededYoutubeLink.js';

const HomeTutorial = ({ heading, description, url }) => {
	// Extract video ID from URL and construct proper embed URL
	// const getEmbedUrl = (url) => {
	//     let videoId;

	//     // Handle different YouTube URL formats
	//     if (url.includes('v=')) {
	//         videoId = url.split('v=')[1];
	//         // Handle additional parameters after video ID
	//         const ampersandPosition = videoId.indexOf('&');
	//         if (ampersandPosition !== -1) {
	//             videoId = videoId.substring(0, ampersandPosition);
	//         }
	//     } else if (url.includes('youtu.be/')) {
	//         videoId = url.split('youtu.be/')[1];
	//     }

	//     // Add additional parameters for better playback reliability
	//     return `https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&enablejsapi=1`;
	// };

	return (
		<div className="home-page-6">
			<div className="home-page-7">
				<Label
					style={{ marginBottom: '20px' }}
					label={heading}
					fontSize={'28px'}
					color={'#07086E'}
					fontWeight={'700'}
					textAlign="left"
				/>
				<Label
					style={{ marginBottom: '20px' }}
					label={description}
					fontSize={'25px'}
					color={'#000000'}
					fontWeight={'400'}
					textAlign="left"
				/>
			</div>
			<div className="video-container">
				<iframe
					className="video-iframe"
					src={getEmbedUrl(url)}
					title="YouTube video player"
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
					style={{ borderRadius: '40px' }}
					loading="lazy"
				/>
			</div>
		</div>
	);
};

export default HomeTutorial;
